import { compose, withHandlers, withStateHandlers } from 'recompose';
import { connect } from 'react-redux';
import { addProps, addIntlProps } from 'utils/recompose';
import { injectIntl } from 'react-intl';
import messages from './messages';
import combineSelectors from 'utils/combineSelectors';
import {
  template,
  functionalGroupTemplates,
  miniDesignOptionKeys,
  swappedTemplate,
} from 'reducers/templates/selectors';
import { inReviewTemplateIds } from 'reducers/models/selectors';
import {
  includes,
  assign,
  values,
  mapValues,
  without,
  every,
  pickBy,
  uniqBy,
} from 'lodash';
import {
  setDuplicateTemplateId,
  setSwappedTemplateId,
} from 'reducers/templates/actions';

const mapStateToProps = combineSelectors({
  template,
  functionalGroupTemplates,
  inReviewTemplateIds,
  miniDesignOptionKeys,
  swappedTemplate,
});

const open = ({ optionKey, selectExpandedOption }) => () =>
  selectExpandedOption(optionKey);
const close = ({ selectExpandedOption }) => () => selectExpandedOption(null);

const optionName = ({ optionKey }) =>
  optionKey
    .replace('Option', '')
    .replace(/([A-Z])/g, ' $1')
    .replace(/^./, function(str) {
      return str.toUpperCase();
    });

export const similarTemplates = ({
  template: { designPackage },
  functionalGroupTemplates,
  inReviewTemplateIds,
  optionKey,
  miniDesignOptionKeys,
  swappedTemplate,
}) => {
  let matchingKeys = without(miniDesignOptionKeys, optionKey);
  const currentDesignPackage = swappedTemplate
    ? swappedTemplate.designPackage
    : designPackage;
  let similarTemplates = pickBy(functionalGroupTemplates, fgt => {
    return (
      every(matchingKeys, key => {
        if (fgt.designPackage[key]) {
          return currentDesignPackage[key].id === fgt.designPackage[key].id;
        }
      }) && !includes(inReviewTemplateIds, fgt.id)
    );
  });
  return similarTemplates;
};

export const alternativeDesigns = ({ similarTemplates, optionKey }) => {
  let designs = values(
    mapValues(similarTemplates, st => {
      return assign(st[optionKey], { templateId: st.id });
    }),
  );
  const uniqueDesigns = uniqBy(designs, 'id');
  return uniqueDesigns;
};

const setSelectedTemplate = () => selectedTemplateId => ({
  selectedTemplateId,
});

const selectTemplateId = ({
  setSwappedTemplateId,
  setSelectedTemplate,
  setDuplicateTemplateId,
  isDuplicate,
  template,
}) => selectedTemplateId => {
  if (isDuplicate) {
    setDuplicateTemplateId(template.id);
    setSwappedTemplateId(selectedTemplateId);
  } else {
    setSwappedTemplateId(selectedTemplateId);
  }
  setSelectedTemplate(selectedTemplateId);
};

export const isOpen = ({ expandedOption, optionKey }) =>
  expandedOption === optionKey;

export default compose(
  injectIntl,
  addIntlProps({
    messages,
    propNames: [],
  }),
  connect(
    mapStateToProps,
    {
      setSwappedTemplateId,
      setDuplicateTemplateId,
    },
  ),
  withStateHandlers({ selectedTemplateId: null }, { setSelectedTemplate }),
  addProps({ optionName, similarTemplates }),
  addProps({
    alternativeDesigns,
    isOpen,
  }),
  withHandlers({
    open,
    close,
    selectTemplateId,
  }),
);
